import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputMultiSelect } from '@/components/Input/InputMultiSelect'

const bedroomOptions = [
  { label: 'Studio', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
]

type Options = typeof bedroomOptions

type Props = {
  beds?: number[]
}

export const BedSelection: FC<Props> = ({ beds }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()
  const initialFilters: Options | undefined = beds
    ? beds.map((v) => {
        if (v === 0) {
          return { label: 'Studio', value: '0' }
        }
        return { label: '' + v, value: '' + v }
      })
    : undefined

  const handleSubmit = (values: { beds?: Options }) => {
    if (values.beds) {
      if (values.beds.length > 0) {
        values.beds &&
          WorkspaceDispatch(WorkspaceAction.updateFilters({ beds: values.beds.map((v) => Number(v.value)) }))
      } else {
        values.beds && WorkspaceDispatch(WorkspaceAction.updateFilters({ beds: undefined }))
      }
    }
  }
  return (
    <Formik
      initialValues={{
        beds: initialFilters,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className=" flex w-1/2 flex-row flex-wrap">
            <InputMultiSelect
              className="w-full"
              id="beds"
              name="beds"
              onChange={submitForm}
              options={bedroomOptions}
              variant="clean"
            />
          </Form>
        )
      }}
    </Formik>
  )
}
